const KEY = 'casino.watch.narration_muted';
export function isNarrationMuted(): boolean { return localStorage.getItem(KEY) === '1'; }
export function setNarrationMuted(muted: boolean): void {
  if (muted) localStorage.setItem(KEY, '1'); else localStorage.removeItem(KEY);
}
